import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home.tsx";
import About from "./pages/About.tsx";
import Contact from "./pages/Contact.tsx";
import Faq from "./pages/Faq.tsx";

import PlansLanding from "./pages/PlansLanding.tsx";
import MobilePlans from "./pages/MobilePlans.tsx";
import MobileCoverage from "./pages/MobileCoverage.tsx";
import WatchEsim from "./pages/WatchEsim.tsx";
import NbnPlans from "./pages/NbnPlans.tsx";
import HostedVoice from "./pages/HostedVoice.tsx";
import SipTrunking from "./pages/SipTrunking.tsx";
import InboundCalls from "./pages/InboundCalls.tsx";
import BusinessFibre from "./pages/BusinessFibre.tsx";
import InternationalRoaming from "./pages/InternationalRoaming.tsx";
import HostedTeams from "./pages/HostedTeams.tsx";
import KeepingUpWithTechnology from "./pages/KeepingUpWithTechnology.tsx";
import WebGraphicDesign from "./pages/WebGraphicDesign.tsx";
import SocialMediaMarketing from "./pages/SocialMediaMarketing.tsx";
import Wholesale from "./pages/Wholesale.tsx";
import Hardware from "./pages/Hardware.tsx";
import Newsroom from "./pages/Newsroom.tsx";
import Terms from "./pages/Terms.tsx";
import FinancialHardship from "./pages/FinancialHardship.tsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.tsx";

import Navbar from "./components/Navbar.tsx";
import Footer from "./components/Footer.tsx";
import ScrollToTop from "./components/ScrollToTop.tsx";

import "./App.css";

export default function App(): JSX.Element {
  return (
    <Router>
      <ScrollToTop />   {/* <-- Added here */}

      <div className="app">
        <Navbar />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<Faq />} />

          {/* Plans hub */}
          <Route path="/plans" element={<PlansLanding />} />

          {/* Sub-pages */}
          <Route path="/plans/mobile" element={<MobilePlans />} />
          <Route path="/plans/mobile/watch-esim" element={<WatchEsim />} />
          <Route path="/mobile-coverage" element={<MobileCoverage />} />
          <Route path="/plans/mobile/coverage" element={<Navigate to="/mobile-coverage" replace />} />
          <Route path="/plans/nbn" element={<NbnPlans />} />
          <Route path="/plans/hosted-voice" element={<HostedVoice />} />
          <Route path="/plans/hostedvoice" element={<Navigate to="/plans/hosted-voice" replace />} />
          <Route path="/plans/sip-trunking" element={<SipTrunking />} />
          <Route path="/plans/siptrunking" element={<Navigate to="/plans/sip-trunking" replace />} />
          <Route path="/plans/inbound-calls" element={<InboundCalls />} />
          <Route path="/plans/business-fibre" element={<BusinessFibre />} />
          <Route path="/plans/mobile/roam" element={<InternationalRoaming />} />
          <Route path="/plans/hosted-teams" element={<HostedTeams />} />
          <Route path="/plans/keep-up-with-technology" element={<KeepingUpWithTechnology />} />
          <Route path="/plans/keeping-up-with-technology" element={<Navigate to="/plans/keep-up-with-technology" replace />} />
          <Route path="/plans/web-design" element={<WebGraphicDesign />} />
          <Route path="/plans/social-media-marketing" element={<SocialMediaMarketing />} />
          <Route path="/wholesale" element={<Wholesale />} />
          <Route path="/hardware" element={<Hardware />} />
          <Route path="/newsroom" element={<Newsroom />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/terms-and-conditions" element={<Terms />} />
          <Route path="/customerterms" element={<Navigate to="/terms" replace />} />
          <Route path="/financial-hardship" element={<FinancialHardship />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>

        <Footer />
      </div>
    </Router>
  );
}
